import type { SVGProps } from 'react';

const Forbid = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8333 8.00008C12.8333 10.6695 10.6694 12.8334 7.99999 12.8334C5.33062 12.8334 3.16666 10.6695 3.16666 8.00008C3.16666 5.33071 5.33062 3.16675 7.99999 3.16675C10.6694 3.16675 12.8333 5.33071 12.8333 8.00008Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66666 4.66675L11.3333 11.3334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Forbid;
